import { LitElement, html, svg } from 'lit';

export class IconDownload24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Pil ned til harddisk</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 3.75v12M7.564 11.313 12 15.75l4.437-4.436M.75 15.9v1.35a3 3 0 0 0 3 3h16.5a3 3 0 0 0 3-3V15.9"></path></svg>`; }
}
if (!customElements.get('f-icon-download24', IconDownload24)) {
  customElements.define('f-icon-download24', IconDownload24);
}